<template>
  <div>
    <va-select
      v-model="selectedusers"
      searchable
      :loading="isLoading"
      textBy="email"
      keyBy="id"
      ref="usersSelect"
      :noClear="false"
      multiple
      :options="users.filter(el => serchFunc(el))"
      @update-search="scrollSelectorAndUpdate"
      :placeholder="label"
      :label="label"
      :disabled="disabledSelectUser"
    />
  </div>

</template>
<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'Selectusers',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: () => '',
    },
    filterBy: {
      type: Object,
      default: () => ({}),
    },
    disabledSelectUser: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      search: '',
      selectedusers: [],
      scrollTop: 0,
      isLoading: true,
      usersQueryParams: {
        page: 1,
        limit: 10,
        ...this.filterBy,
      },
    }
  },
  watch: {
    value: function () {
      if (this.value.length !== this.selectedusers.length) {
        this.selectedusers =
          this.users.filter(el => this.value.includes(el.id)) ?? []
      }
    },
    selectedusers: {
      deep: true,
      handler: async function () {
        await this.$emit('input', this.selectedusers.map(el => el.id))

        this.$nextTick(() => {
          const contentSelector = this.$refs.usersSelect.$el.querySelector(
            '.va-dropdown__content',
          )
          if (contentSelector) {
            this.$refs.usersSelect.closeDropdown()
            contentSelector.scrollTop = this.scrollTop
            this.$refs.usersSelect.openDropdown()
          }
        })
      },
    },
  },
  computed: {
    ...mapState({
      users: state => state.Users.itemsMore,
      haveusers: state => state.Users.hasItemsMore,
    }),
  },
  methods: {
    serchFunc(el) {
      if (el.email === '') return false
      let filter = el.email?.toLowerCase()?.includes(this.search?.toLowerCase())
      if (Object.keys(this.filterBy).length > 0) {
        for (const key in this.filterBy) {
          filter = el[key] === this.filterBy[key]
        }
      }
      return filter
    },
    scrollSelectorAndUpdate: debounce(function (e) {
      this.$nextTick(async () => {
        const contentSelector = this.$refs.usersSelect.$el.querySelector(
          '.va-dropdown__content',
        )
        this.scrollTop = contentSelector?.scrollTop

        if (typeof e === 'string') {
          this.search = e
          if (e) {
            console.log(e)
            await this.$refs.usersSelect.closeDropdown()
            // await this.$refs.usersSelect.clear()
            await this.$refs.usersSelect.openDropdown()
          }
        }
        if (
          this.haveusers &&
          contentSelector?.scrollHeight - 50 <
          contentSelector?.scrollTop + contentSelector?.clientHeight
        ) {
          this.usersQueryParams.page++
          this.isLoading = true
          await this.getItemsMore(this.usersQueryParams)
          this.isLoading = false
        }
      })
    }, 500),
    ...mapActions('Users', ['getItemsMore', 'getItem']),
    async setOptions() {
      this.isLoading = true
      await this.getItemsMore(this.usersQueryParams)
      this.isLoading = false
      if (Array.isArray(this.value)) {
        this.selectedusers =
          this.users.filter(el => this.value.includes(el.id)) ?? []
      }
    },
  },
  created() {
    this.setOptions()
    this.$nextTick(() => {
      this.$refs.usersSelect.$el.onwheel = this.scrollSelectorAndUpdate
    })
  },
}
</script>
